import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const OnlineStatusIndicator = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./online-status-indicator.html'),
    data() {
        return {
            onLine: true,
            running: false,
        }
    },
    created() {
        this.running = true;
        this.onFrame();
    },
    beforeUnmount() {
        this.running = false;
    },
    methods: {
        onFrame() {
            this.onLine = window.navigator.onLine;

            if (this.running) {
                requestAnimationFrame(this.onFrame);
            }
        },
    },
})
